import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import {
  formatTotalHours,
  getAllMonths,
  getAllYears,
  getFieldData,
  getMonthLastDay,
  getMonthName,
  getTotalDays,
  getTotalHours,
} from "../../../services/appService";
import { getAlert, getConfirmAlert } from "../../../services/appAlerts";
import {
  getTimeLogDuration,
  getTimeLogs,
  getTimeLogsLoading,
  loadTimeLogDuration,
  loadTimeLogs,
} from "../../store/timeLog";
import {
  deleteAgencyTimeLogInvDoc,
  getAgencyTimeLogInvDocDeleteStatus,
  getTimeLogInvoice,
  loadTimeLogInvoice,
} from "../../store/timeLogInvoice";
import AddNewTimeLog from "../../../components/OMCRegistry/AddNewTimeLog";
import CandidatePay from "../../../components/OMCRegistry/CandidatePay";
import UploadInvoice from "../../../components/OMCRegistry/UploadInvoice";
import { getCandidateApps, loadCandidateApps } from "../../store/candidate";
import { getCurrentUser } from "../../store/auth";
import useDocDownload from "../../hooks/useDocDownload";

export default function Agency(props) {
  const { candidate, ptype, entType, wfTask, allRates } = props;

  const [timeLogs, setTimeLogs] = useState([]);
  const [timeLogInvoices, setTimeLogInvoices] = useState([]);
  const [applications, setApplications] = useState([]);
  const [timeLogShowHide, setTimeLogShowHide] = useState(false);
  const [projectStartDate, setProjectStartDate] = useState("");
  const [projectStDt, setProjectStDt] = useState("");
  const [currentStDt, setCurrentStDt] = useState("");
  const [payShowHide, setPayShowHide] = useState(false);
  const [invShowHide, setInvShowHide] = useState(false);
  const [invType, setInvType] = useState("agency");
  const [timeLogObj, setTimeLogObj] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [filterMonth, setFilterMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  //const [workItem, setWorkItem] = useState(null);

  const [lastLoadedId, setLastLoadedId] = useState(null);
  const timeLogsSelector = useSelector(getTimeLogs);
  const isTimeLogsLoading = useSelector(getTimeLogsLoading);
  const timeLogsInvoiceSelector = useSelector(getTimeLogInvoice);
  const candidateAppsSelector = useSelector(getCandidateApps);
  const timeLogDurationSelector = useSelector(getTimeLogDuration);
  const timeLogInvDocDeleteStatusSelector = useSelector(
    getAgencyTimeLogInvDocDeleteStatus,
  );

  const years = getAllYears();
  const months = getAllMonths();
  const perfData = candidate?.performerData;
  const agencyRate = candidate.rates?.agencyRate;
  const agencyDate = candidate.rates?.agencyEffectiveDate;

  const [handleDownloadFile] = useDocDownload();

  const dispatch = useDispatch();
  const sortTimeLogsByLatestPeriod = (logs = []) =>
    [...logs].sort((a, b) => {
      const yearDiff =
        (parseInt(b?.year, 10) || 0) - (parseInt(a?.year, 10) || 0);
      if (yearDiff !== 0) return yearDiff;

      return (parseInt(b?.month, 10) || 0) - (parseInt(a?.month, 10) || 0);
    });

  const currentUser = getCurrentUser();

  useEffect(() => {
    if (candidate?.id) {
      dispatch(loadTimeLogs(candidate.id));
      dispatch(loadTimeLogInvoice(candidate.id));
      dispatch(loadTimeLogDuration(candidate.id));
      setSelectedYear("");
      setSelectedMonth("");
      setFilterYear("");
      setFilterMonth("");
      setLastLoadedId(candidate.id);
    }
  }, [candidate?.id]);

  useEffect(() => {
    if (timeLogsInvoiceSelector.length > 0) {
      const subcontractorInvoices = timeLogsInvoiceSelector.filter(
        (x) => x.invoiceType === invType,
      );
      setTimeLogInvoices(subcontractorInvoices);
    }
    if (timeLogDurationSelector?.startDate) {
      const startDate = new Date(timeLogDurationSelector.startDate);
      startDate.setDate(startDate.getDate() + 1); // add 1 day
      const result = startDate.toISOString().substring(0, 10);
      setProjectStDt(startDate);
      setCurrentStDt(timeLogDurationSelector.projectStartedDate);
    }
  }, [timeLogsInvoiceSelector, timeLogDurationSelector]);

  useEffect(() => {
    let filterTimeLogs = [...timeLogsSelector];
    if (filterYear > 0)
      filterTimeLogs = filterTimeLogs.filter(
        (x) => x.year === parseInt(filterYear),
      );

    if (filterMonth > 0)
      filterTimeLogs = filterTimeLogs.filter(
        (x) => x.month === parseInt(filterMonth),
      );

    setTimeLogs(sortTimeLogsByLatestPeriod(filterTimeLogs));
  }, [timeLogsSelector, filterMonth, filterYear]);

  useEffect(() => {
    if (timeLogInvDocDeleteStatusSelector) {
      getAlert("", "Successfully Deleted.", "success");
      if (candidate?.id) dispatch(loadTimeLogInvoice(candidate.id));
    }
  }, [timeLogInvDocDeleteStatusSelector]);

  const handleApplyFilter = () => {
    setFilterYear(selectedYear);
    setFilterMonth(selectedMonth);
  };

  const handleResetFilter = () => {
    setSelectedYear("");
    setSelectedMonth("");
    setFilterYear("");
    setFilterMonth("");
  };

  const getMonthlyPeriod = (obj) => {
    if (!obj?.workingHrs) return "";
    const wt = JSON.parse(obj.workingHrs);
    const sortWt = wt.sort((a, b) => new Date(a.start) - new Date(b.start));
    if (sortWt.length > 0) {
      return (
        <div>
          <Moment format="MM/DD/YYYY">{sortWt[0].start}</Moment>-
          <Moment format="MM/DD/YYYY">
            {sortWt[sortWt.length - 1].type === "m"
              ? getMonthLastDay(sortWt[sortWt.length - 1].start)
              : sortWt[sortWt.length - 1].start}
          </Moment>
        </div>
      );
    }

    return "";
  };

  const getAgencyInvoice = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.invDoc !== null,
    );

    if (tmLogs.length === 0) {
      return (
        <button
          type="button"
          className="wf-btn-add"
          style={{ height: "30px", padding: "0 10px", fontSize: "12px" }}
          onClick={() => handleInvShowHide(item)}
        >
          <i className="fa fa-upload" /> Upload
        </button>
      );
    }

    return (
      <div className="wf-status-stack">
        {tmLogs.map((inv, index) => (
          <React.Fragment key={inv.id || index}>
            <span
              style={{ fontWeight: 700, fontSize: "13px", color: "#334155" }}
            >
              Inv: {inv.invoiceNumber}
            </span>
            {inv.invDoc && (
              <div className="wf-doc-row">
                <button
                  type="button"
                  className="wf-doc-link"
                  onClick={() => handleDownloadFile(inv.invDoc)}
                  title={inv.invDoc.documentName}
                >
                  <i
                    className="fa fa-file-pdf-o"
                    style={{ color: "#ef4444", marginRight: "4px" }}
                  />
                  {inv.invDoc.documentName.length > 15
                    ? inv.invDoc.documentName.substring(0, 15) + "..."
                    : inv.invDoc.documentName}
                </button>
              </div>
            )}
            <button
              type="button"
              style={{
                border: "none",
                background: "transparent",
                color: "#ef4444",
                padding: 0,
                fontSize: "11px",
                fontWeight: 700,
                cursor: "pointer",
                outline: "none",
                marginTop: "2px",
              }}
              title="Delete Invoice Document"
              onClick={() => handleDeleteInvoiceDoc(inv.id)}
            >
              <i className="fa fa-trash-o" /> Delete/Regenerate
            </button>
          </React.Fragment>
        ))}
      </div>
    );
  };

  const handleDeleteInvoiceDoc = async (id) => {
    const result = await getConfirmAlert(
      "",
      "Are you sure you want to delete this document?",
      "error",
    );
    if (result.isConfirmed) {
      dispatch(deleteAgencyTimeLogInvDoc(id));
    }
  };

  const getApplicableRateDetails = (item) => {
    const itemYear = parseInt(item?.year, 10);
    const itemMonth = parseInt(item?.month, 10);
    const rateField = "agencyRate";
    const dateField = "agencyEffectiveDate";
    const matchedRate = Array.isArray(allRates)
      ? allRates.reduce((best, rate, index) => {
        if (!itemYear || !itemMonth) return best;

        const effMs = new Date(rate?.[dateField]).getTime();
        if (Number.isNaN(effMs)) return best;

        const effDt = new Date(effMs);
        const effYear = effDt.getFullYear();
        const effMonth = effDt.getMonth() + 1;
        const isApplicable =
          effYear < itemYear ||
          (effYear === itemYear && effMonth <= itemMonth);

        if (!isApplicable) return best;
        if (!best) return { rate, index, effMs };

        if (effMs > best.effMs) return { rate, index, effMs };
        if (effMs < best.effMs) return best;

        const addedMs = new Date(rate?.addedDateTime).getTime();
        const bestAddedMs = new Date(best.rate?.addedDateTime).getTime();
        const safeAddedMs = Number.isNaN(addedMs) ? -Infinity : addedMs;
        const safeBestAddedMs = Number.isNaN(bestAddedMs)
          ? -Infinity
          : bestAddedMs;

        if (safeAddedMs > safeBestAddedMs) return { rate, index, effMs };
        if (safeAddedMs < safeBestAddedMs) return best;

        const idNum = Number(rate?.id);
        const bestIdNum = Number(best.rate?.id);
        const safeIdNum = Number.isFinite(idNum) ? idNum : -Infinity;
        const safeBestIdNum = Number.isFinite(bestIdNum)
          ? bestIdNum
          : -Infinity;

        if (safeIdNum > safeBestIdNum) return { rate, index, effMs };
        if (safeIdNum < safeBestIdNum) return best;

        return index > best.index ? { rate, index, effMs } : best;
      }, null)?.rate
      : null;

    const fallbackRate = 0; //parseFloat(agencyRate || 0);
    const rateValue =
      matchedRate?.[rateField] !== null &&
        matchedRate?.[rateField] !== undefined &&
        matchedRate?.[rateField] !== ""
        ? parseFloat(matchedRate[rateField])
        : fallbackRate;

    const effectiveDate = matchedRate?.[dateField] || "";
    return {
      rate: rateValue,
      effectiveDate,
    };
  };

  const getInvoiceAmount = (item) => {
    const totHrs = getTotalHours(item?.workingHrs || 0);
    const { rate: applicableRate } = getApplicableRateDetails(item);
    let invAmt = totHrs * applicableRate;

    // If not W2, return straight amount
    if (entType !== "W2 Basis") {
      return parseFloat(invAmt || 0).toFixed(2);
    }

    // W2 → add tax
    const taxRate =
      (getFieldData(perfData, "candidateonboardingform", "Tax") || 0) / 100;
    invAmt = invAmt + invAmt * taxRate;

    return parseFloat(invAmt || 0).toFixed(2);
  };

  const getFinalAmout = (obj) => {
    let fAmt = parseFloat(getInvoiceAmount(obj));
    const invItems = timeLogInvoices.filter((x) => x.timeLogId === obj.id);
    if (invItems.length > 0) {
      const item = invItems[0];
      if (item?.adjustmentMinues > 0) fAmt -= item.adjustmentMinues;
      if (item?.adjustmentPlus > 0) fAmt += item.adjustmentPlus;
      if (item?.adpDeduction > 0) fAmt -= item.adpDeduction;
      return parseFloat(fAmt || 0).toFixed(2);
    } else {
      return parseFloat(fAmt || 0).toFixed(2);
    }
  };

  const getPaymentStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.paymentMode !== null,
    );

    if (tmLogs.length === 0) {
      return (
        <button
          type="button"
          className="wf-status-pill wf-status-pending"
          style={{ cursor: "pointer", outline: "none" }}
          onClick={() => handlePayShowHide(item)}
        >
          <i className="fa fa-credit-card" aria-hidden="true"></i> Pending
        </button>
      );
    }

    return (
      <div className="wf-status-stack">
        {tmLogs.map((pay, index) => (
          <React.Fragment key={pay.id || index}>
            <button
              type="button"
              className="wf-status-pill wf-status-approved"
              style={{ cursor: "pointer", outline: "none" }}
              onClick={() => handlePayShowHide(item)}
            >
              <i className="fa fa-check-circle" aria-hidden="true"></i> Received
              ($
              {parseFloat(pay.paidAmount || 0).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              )
            </button>
            {pay.addedDateTime && (
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  marginTop: "4px",
                }}
              >
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "20px",
                    height: "20px",
                    borderRadius: "5px",
                    background: "#faf5ff",
                    color: "#7c3aed",
                    fontSize: "11px",
                    flexShrink: 0,
                  }}
                >
                  <i className="fa fa-calendar-o" />
                </div>
                <span
                  style={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#475569",
                    lineHeight: 1,
                  }}
                >
                  <Moment format="MMM Do YYYY">{pay.addedDateTime}</Moment>
                </span>
              </div>
            )}
            {pay?.docList && pay.docList.length > 0 && (
              <ul className="wf-doc-list" style={{ marginTop: "4px" }}>
                {pay.docList.map((doc, idx) => (
                  <li key={idx} className="wf-doc-row">
                    <button
                      type="button"
                      className="wf-doc-link"
                      onClick={() => handleDownloadFile(doc)}
                      title={doc.documentName}
                    >
                      <i className="fa fa-paperclip" />{" "}
                      {doc.documentName.length > 15
                        ? doc.documentName.substring(0, 15) + "..."
                        : doc.documentName}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  const getDueAmountStatus = (item) => {
    const tmLogs = timeLogInvoices.filter(
      (x) => x.timeLogId === item.id && x.paidAmount !== null,
    );

    if (tmLogs.length === 0) return "";

    const finalAmount = parseFloat(getFinalAmout(item));
    const validFinalAmount = isNaN(finalAmount) ? 0 : finalAmount;

    return (
      <>
        {tmLogs.map((inv, index) => {
          const paid = parseFloat(inv.paidAmount);
          const validPaid = isNaN(paid) ? 0 : paid;
          const due = (validFinalAmount - validPaid).toFixed(2);
          return <span key={index}>{due}</span>;
        })}
      </>
    );
  };

  const handleShowHide = async (obj) => {
    if (obj === "save") {
      setTimeLogShowHide(false);
      setTimeLogObj("");
      if (candidate?.id) dispatch(loadTimeLogs(candidate.id));
    } else {
      setTimeLogShowHide(!timeLogShowHide);

      setTimeLogObj(obj);
    }
  };

  const handlePayShowHide = async (obj) => {
    if (obj === "save") {
      setPayShowHide(false);
      setTimeLogObj("");
      if (candidate?.id) dispatch(loadTimeLogInvoice(candidate?.id));
    } else {
      if (obj === "close") {
        setPayShowHide(false);
        setTimeLogObj("");
      } else {
        const chkInvoice = timeLogInvoices.filter(
          (x) => x.timeLogId === obj.id && x.invDoc !== null,
        );
        // if (chkInvoice.length > 0 || entType !== "C2C Basis") {
        if (chkInvoice.length > 0) {
          setPayShowHide(!payShowHide);
          setTimeLogObj(obj);
        } else {
          getAlert("", "Invoice not generated", "error");
        }
      }
    }
  };

  const handleInvShowHide = async (obj) => {
    if (obj === "save") {
      setInvShowHide(false);
      setTimeLogObj("");
      if (candidate?.id) dispatch(loadTimeLogInvoice(candidate.id));
    } else {
      setInvShowHide(!invShowHide);
      setTimeLogObj(obj);
    }
  };

  // Computations for Stats Header
  const totalMinutes = timeLogs.reduce((sum, log) => {
    if (!log?.workingHrs) return sum;
    let wt;
    try {
      wt = JSON.parse(log.workingHrs);
    } catch (e) {
      return sum;
    }
    if (!Array.isArray(wt)) return sum;
    let logMinutes = 0;
    wt.filter((x) => x.title !== null).forEach((t) => {
      const parts = t.title.toString().split(".");
      const hours = parseInt(parts[0], 10) || 0;
      const minutes = parseInt(parts[1], 10) || 0;
      logMinutes += hours * 60 + minutes;
    });
    return sum + logMinutes;
  }, 0);

  const statHours = Math.floor(totalMinutes / 60);
  const statMinutes = totalMinutes % 60;
  const totalHoursStr = `${statHours}h ${statMinutes}m`;

  const totalDaysVal = timeLogs.reduce(
    (sum, log) => sum + getTotalDays(log?.workingHrs),
    0,
  );

  const reviewedLogsCount = timeLogs.filter((log) =>
    timeLogInvoices.some(
      (inv) => inv.timeLogId === log.id && inv.status !== null,
    ),
  ).length;

  const paidLogsCount = timeLogs.filter((log) =>
    timeLogInvoices.some(
      (inv) =>
        inv.timeLogId === log.id &&
        (inv.paymentMode !== null ||
          (inv.paidAmount !== null && parseFloat(inv.paidAmount) > 0)),
    ),
  ).length;

  const reviewedPaidStr = `${reviewedLogsCount} / ${paidLogsCount}`;

  return (
    <React.Fragment>
      <div className="wf-controls-card">
        <div className="wf-controls-left">
          <div className="wf-select-wrapper">
            <i className="fa fa-calendar wf-select-icon"></i>
            <select
              name="filterYear"
              id="filterYear"
              className="wf-control-select"
              aria-label="Select Year"
              value={selectedYear}
              onChange={({ currentTarget }) =>
                setSelectedYear(currentTarget.value)
              }
            >
              <option value="">Year</option>
              {years.map((y) => (
                <option key={y.name} value={y.name}>
                  {y.name}
                </option>
              ))}
            </select>
          </div>
          <div className="wf-select-wrapper">
            <i className="fa fa-filter wf-select-icon"></i>
            <select
              name="filterMonth"
              id="filterMonth"
              className="wf-control-select"
              aria-label="Select Month"
              value={selectedMonth}
              onChange={({ currentTarget }) =>
                setSelectedMonth(currentTarget.value)
              }
            >
              <option value="">Month</option>
              {months.map((m) => (
                <option key={m.id} value={m.id}>
                  {m.name}
                </option>
              ))}
            </select>
          </div>
          <button
            type="button"
            onClick={handleApplyFilter}
            className="wf-btn-apply"
          >
            <i className="fa fa-search"></i> Apply Filter
          </button>
          <button
            type="button"
            onClick={handleResetFilter}
            className="wf-btn-reset"
          >
            <i className="fa fa-refresh"></i> Reset
          </button>
        </div>
      </div>
      <div className="wf-stats-row">
        <div className="wf-stat-card">
          <div className="wf-stat-header-row">
            <span className="wf-stat-label">Time Logs</span>
            <div className="wf-stat-icon-wrap">
              <i className="fa fa-file-text-o"></i>
            </div>
          </div>
          <div className="wf-stat-value">{timeLogs.length}</div>
          <div className="wf-stat-hint">
            Submitted time log periods currently available.
          </div>
        </div>
        <div className="wf-stat-card">
          <div className="wf-stat-header-row">
            <span className="wf-stat-label">Total Hours</span>
            <div className="wf-stat-icon-wrap">
              <i className="fa fa-clock-o"></i>
            </div>
          </div>
          <div className="wf-stat-value">{totalHoursStr}</div>
          <div className="wf-stat-hint">
            Combined hours logged across all visible periods.
          </div>
        </div>
        <div className="wf-stat-card">
          <div className="wf-stat-header-row">
            <span className="wf-stat-label">Total Days</span>
            <div className="wf-stat-icon-wrap">
              <i className="fa fa-calendar-check-o"></i>
            </div>
          </div>
          <div className="wf-stat-value">{totalDaysVal}</div>
          <div className="wf-stat-hint">
            Working days recorded from submitted time logs.
          </div>
        </div>
        <div className="wf-stat-card">
          <div className="wf-stat-header-row">
            <span className="wf-stat-label">Reviewed / Paid</span>
            <div className="wf-stat-icon-wrap">
              <i className="fa fa-credit-card"></i>
            </div>
          </div>
          <div className="wf-stat-value">{reviewedPaidStr}</div>
          <div className="wf-stat-hint">
            Periods reviewed by IPCS and periods with payment activity.
          </div>
        </div>
      </div>
      <div className="table-responsive mt-2 wf-table-scroll">
        <table className="table align-items-center table-flush table-striped wf-table agency-invoices-table">
          <thead className="wf-thead">
            <tr>
              <th>Year</th>
              <th>Month</th>
              <th>
                Period
                <span className="wf-thead-subtext">Time Logged</span>
              </th>
              <th>
                Hours
                <span className="wf-thead-subtext">Days</span>
              </th>
              <th>
                Approved
                <span className="wf-thead-subtext">Timesheets</span>
              </th>
              <th>Rate/$Hr</th>
              <th>
                Invoice
                <span className="wf-thead-subtext">Amount ($)</span>
              </th>
              <th>Invoice</th>
              <th>Payment Status</th>
            </tr>
          </thead>
          <tbody>
            {isTimeLogsLoading || lastLoadedId !== candidate?.id ? (
              <tr>
                <td
                  colSpan={9}
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      fontSize: "28px",
                      marginBottom: "10px",
                      color: "#2563eb",
                    }}
                  >
                    <i className="fa fa-spinner fa-spin"></i>
                  </div>
                  <div style={{ fontWeight: 600, fontSize: "15px" }}>
                    Loading Time Logs...
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#94a3b8",
                      marginTop: "4px",
                    }}
                  >
                    Please wait while we fetch the latest records.
                  </div>
                </td>
              </tr>
            ) : timeLogs.length === 0 ? (
              <tr>
                <td
                  colSpan={9}
                  style={{
                    textAlign: "center",
                    padding: "40px 20px",
                    color: "#64748b",
                  }}
                >
                  <div style={{ fontSize: "24px", marginBottom: "10px" }}>
                    <i className="fa fa-folder-open-o"></i>
                  </div>
                  <div style={{ fontWeight: 600, fontSize: "15px" }}>
                    No Time Logs Found
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#94a3b8",
                      marginTop: "4px",
                    }}
                  >
                    There are no time logs available.
                  </div>
                </td>
              </tr>
            ) : (
              timeLogs.map((item) => (
                <tr key={item.id} className="wf-table-row">
                  <td>
                    <span style={{ fontWeight: 700, color: "#1e293b" }}>
                      {item.year}
                    </span>
                  </td>
                  <td>
                    <span style={{ fontWeight: 600, color: "#334155" }}>
                      {getMonthName(item.month)}
                    </span>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="wf-period-btn"
                      onClick={() => handleShowHide(item)}
                    >
                      <i
                        className="fa fa-calendar-o wf-period-icon"
                        aria-hidden="true"
                      ></i>
                      <span>{getMonthlyPeriod(item)}</span>
                    </button>
                  </td>
                  <td>
                    <button
                      type="button"
                      className="wf-metric-btn"
                      onClick={() => handleShowHide(item)}
                    >
                      <span className="wf-metric-primary">
                        <i className="fa fa-clock-o" aria-hidden="true"></i>
                        {formatTotalHours(item?.workingHrs)}
                      </span>
                      <span className="wf-metric-secondary">
                        {getTotalDays(item.workingHrs)}{" "}
                        {getTotalDays(item.workingHrs) > 1 ? "Days" : "Day"}
                      </span>
                    </button>
                  </td>
                  <td>
                    {item.docList && item.docList.length > 0 ? (
                      <ul className="wf-doc-list">
                        {item.docList.map((doc, idx) => (
                          <li key={idx} className="wf-doc-row">
                            <button
                              type="button"
                              className="wf-doc-link"
                              onClick={() => handleDownloadFile(doc)}
                              title={doc.documentName}
                            >
                              <i
                                className="fa fa-paperclip"
                                aria-hidden="true"
                              ></i>
                              {doc.documentName.length > 15
                                ? doc.documentName.substring(0, 15) + "..."
                                : doc.documentName}
                            </button>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <span style={{ color: "#94a3b8" }}>—</span>
                    )}
                  </td>
                  <td>
                    {(() => {
                      const { rate, effectiveDate } =
                        getApplicableRateDetails(item);
                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "4px",
                          }}
                        >
                          <div
                            style={{
                              fontSize: "13.5px",
                              fontWeight: 800,
                              color: "#0f172a",
                              display: "inline-flex",
                              alignItems: "center",
                            }}
                          >
                            $
                            {parseFloat(rate || 0).toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                            <span
                              style={{
                                color: "#64748b",
                                fontSize: "11px",
                                fontWeight: 600,
                                textTransform: "uppercase",
                                marginLeft: "4px",
                              }}
                            >
                              / hr
                            </span>
                          </div>
                          {effectiveDate && (
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "11px",
                                  fontWeight: 700,
                                  color: "#64748b",
                                }}
                              >
                                Eff:
                              </span>
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "16px",
                                  height: "16px",
                                  borderRadius: "4px",
                                  background: "#faf5ff",
                                  color: "#7c3aed",
                                  fontSize: "9px",
                                  flexShrink: 0,
                                }}
                              >
                                <i className="fa fa-calendar-o" />
                              </div>
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  color: "#475569",
                                }}
                              >
                                <Moment format="MMM Do YYYY">
                                  {effectiveDate}
                                </Moment>
                              </span>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </td>
                  <td>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        fontSize: "13.5px",
                        fontWeight: 800,
                        color: "#1e293b",
                        background: "#f1f5f9",
                        border: "1px solid #e2e8f0",
                        borderRadius: "6px",
                        padding: "4px 8px",
                      }}
                    >
                      $
                      {(() => {
                        const { rate } = getApplicableRateDetails(item);
                        return Number(
                          parseFloat(
                            getTotalHours(item?.workingHrs) * rate,
                          ).toFixed(2),
                        ).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        });
                      })()}
                    </div>
                  </td>
                  <td>{getAgencyInvoice(item)}</td>
                  <td>{getPaymentStatus(item)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
      <UploadInvoice
        invShowHide={invShowHide}
        handleInvShowHide={handleInvShowHide}
        selectedObj={timeLogObj}
        candidateObj={candidate}
        wfTask={wfTask}
      ></UploadInvoice>
      <CandidatePay
        payShowHide={payShowHide}
        handlePayShowHide={handlePayShowHide}
        candidateObj={candidate}
        selectedObj={timeLogObj}
        invType={invType}
        timeLogInvoices={timeLogInvoices}
        getInvoiceAmount={getInvoiceAmount}
        entType={entType}
        wfTask={wfTask}
      ></CandidatePay>
      {timeLogShowHide && (
        <AddNewTimeLog
          showHide={timeLogShowHide}
          handleShowHide={handleShowHide}
          selectedObj={timeLogObj}
          allTimeLogs={timeLogs}
          candidateObj={candidate}
          timeLogInvoices={timeLogInvoices}
          projectStartDate={projectStDt}
        ></AddNewTimeLog>
      )}
      <style>{`
                /* Modern Table Style matching WorkflowUser */
                .wf-table {
                  width: 100% !important;
                  border-collapse: separate !important;
                  border-spacing: 0 2px !important;
                }

                .wf-table-scroll {
                  overflow: auto !important;
                  scrollbar-width: thin;
                  scrollbar-color: #94a3b8 #f1f5f9;
                  border-radius: 12px;
                  border: 1px solid #cbd5e1 !important;
                  background-color: #ffffff;
                }

                .wf-table-scroll::-webkit-scrollbar {
                  width: 8px;
                  height: 8px;
                }

                .wf-table-scroll::-webkit-scrollbar-track {
                  background: #f1f5f9;
                  border-radius: 999px;
                }

                .wf-table-scroll::-webkit-scrollbar-thumb {
                  background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%);
                  border-radius: 999px;
                  border: 2px solid #f1f5f9;
                }

                .wf-table-scroll::-webkit-scrollbar-thumb:hover {
                  background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%);
                }

                .wf-thead {
                  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                  position: sticky !important;
                  top: 0 !important;
                  z-index: 2 !important;
                }

                .wf-thead th {
                  font-size: 11.5px !important;
                  font-weight: 700 !important;
                  color: #475569 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.6px !important;
                  padding: 13px 16px !important;
                  border-bottom: 2px solid #e2e8f0 !important;
                  border-top: none !important;
                  white-space: nowrap !important;
                }

                .wf-table-row {
                  cursor: pointer !important;
                  transition: background 0.15s ease, box-shadow 0.15s ease, transform 0.1s ease !important;
                }

                .wf-table-row:hover {
                  background: linear-gradient(90deg, rgba(37,99,235,0.04) 0%, rgba(37,99,235,0.015) 100%) !important;
                  box-shadow: inset 3px 0 0 0 rgba(37,99,235,0.35) !important;
                }

                .wf-table-row:hover td {
                  color: #1e293b !important;
                }

                .wf-table-row:active {
                  transform: scaleY(0.98) !important;
                }

                .wf-table td {
                  padding: 13px 16px !important;
                  font-size: 13.5px !important;
                  color: #334155 !important;
                  border-bottom: 1px solid #f1f5f9 !important;
                  vertical-align: top !important;
                  transition: color 0.15s ease !important;
                }

                .wf-table tbody tr:last-child td {
                  border-bottom: none !important;
                }

                .wf-thead-subtext {
                  display: block !important;
                  font-size: 9.5px !important;
                  font-weight: 600 !important;
                  letter-spacing: 0.4px !important;
                  text-transform: none !important;
                  color: #64748b !important;
                  margin-top: 4px !important;
                }

                /* Premium Stats Header Row styling */
                .wf-stats-row {
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  gap: 16px;
                  margin-bottom: 24px;
                }

                @media (max-width: 992px) {
                  .wf-stats-row {
                    grid-template-columns: repeat(2, 1fr);
                  }
                }

                @media (max-width: 576px) {
                  .wf-stats-row {
                    grid-template-columns: 1fr;
                  }
                }

                .wf-stat-card {
                  background: linear-gradient(180deg, #ffffff 0%, #fcfdfe 100%);
                  border: 1px solid rgba(226, 232, 240, 0.9);
                  border-radius: 16px;
                  padding: 20px 22px;
                  box-shadow: 0 10px 30px -10px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
                  display: flex;
                  flex-direction: column;
                  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                  position: relative;
                  overflow: hidden;
                }

                .wf-stat-card:hover {
                  transform: translateY(-3px);
                  box-shadow: 0 20px 35px -15px rgba(37, 99, 235, 0.12), 0 4px 6px -4px rgba(37, 99, 235, 0.08);
                  border-color: rgba(37, 99, 235, 0.25);
                }

                .wf-stat-card::before {
                  content: "";
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #2563eb, #3b82f6);
                  opacity: 0;
                  transition: opacity 0.25s ease;
                }

                .wf-stat-card:hover::before {
                  opacity: 1;
                }

                .wf-stat-header-row {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: 12px;
                }

                .wf-stat-label {
                  font-size: 11px;
                  font-weight: 700;
                  text-transform: uppercase;
                  color: #64748b;
                  letter-spacing: 0.08em;
                  margin: 0;
                }

                .wf-stat-icon-wrap {
                  width: 32px;
                  height: 32px;
                  border-radius: 10px;
                  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                  color: #2563eb;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 14px;
                  border: 1px solid rgba(191, 219, 254, 0.5);
                }

                .wf-stat-value {
                  font-size: 26px;
                  font-weight: 800;
                  color: #0f172a;
                  margin-bottom: 6px;
                  letter-spacing: -0.02em;
                  line-height: 1.15;
                }

                .wf-stat-hint {
                  font-size: 11.5px;
                  color: #64748b;
                  line-height: 1.5;
                  margin-top: auto;
                }

                /* Premium Controls Card */
                .wf-controls-card {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  gap: 16px;
                  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
                  border: 1px solid rgba(226, 232, 240, 0.9);
                  border-radius: 16px;
                  padding: 16px 24px;
                  margin-bottom: 24px;
                  box-shadow: 0 10px 30px -10px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.02);
                }

                @media (max-width: 576px) {
                  .wf-controls-card {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 14px;
                    padding: 16px;
                  }
                }

                .wf-controls-left {
                  display: flex;
                  align-items: center;
                  gap: 16px;
                  flex-wrap: wrap;
                }

                @media (max-width: 576px) {
                  .wf-controls-left {
                    flex-direction: column;
                    align-items: stretch;
                    gap: 12px;
                  }
                }

                /* Select wrapper with prepended icon */
                .wf-select-wrapper {
                  position: relative;
                  display: inline-flex;
                  align-items: center;
                }

                @media (max-width: 576px) {
                  .wf-select-wrapper {
                    width: 100%;
                  }
                }

                .wf-select-icon {
                  position: absolute;
                  left: 14px;
                  color: #64748b;
                  font-size: 13.5px;
                  pointer-events: none;
                  z-index: 2;
                }

                .wf-control-select {
                  height: 38px;
                  min-width: 150px;
                  border-radius: 10px !important;
                  border: 1.5px solid #e2e8f0 !important;
                  padding: 0 36px 0 36px !important;
                  font-size: 13.5px !important;
                  font-weight: 600 !important;
                  color: #334155 !important;
                  background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 14px center !important;
                  appearance: none !important;
                  -webkit-appearance: none !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  cursor: pointer;
                  outline: none !important;
                }

                @media (max-width: 576px) {
                  .wf-control-select {
                    width: 100%;
                  }
                }

                .wf-control-select:hover {
                  border-color: #cbd5e1 !important;
                  background-color: #fafbfc !important;
                }

                .wf-control-select:focus {
                  border-color: #2563eb !important;
                  box-shadow: 0 0 0 3.5px rgba(37, 99, 235, 0.08) !important;
                  background-color: #ffffff !important;
                }

                 .wf-btn-add {
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   gap: 8px;
                   height: 38px;
                   padding: 0 18px;
                   border-radius: 10px;
                   border: 1px solid rgba(37, 99, 235, 0.15);
                   background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                   color: #ffffff;
                   font-size: 13.5px;
                   font-weight: 700;
                   cursor: pointer;
                   transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                   outline: none;
                   box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
                 }

                 .wf-btn-add i {
                   font-size: 12px;
                   color: #ffffff;
                   font-weight: bold;
                 }

                 .wf-btn-add:hover {
                   background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                   border-color: rgba(37, 99, 235, 0.3);
                   color: #ffffff;
                   transform: translateY(-1px);
                   box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
                 }

                 .wf-btn-add:active {
                   transform: scale(0.97);
                 }

                .wf-btn-apply {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  height: 38px;
                  padding: 0 18px;
                  border-radius: 10px;
                  border: 1px solid rgba(37, 99, 235, 0.15);
                  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                  color: #ffffff;
                  font-size: 13.5px;
                  font-weight: 700;
                  cursor: pointer;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                  outline: none;
                  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.15);
                }

                .wf-btn-apply i {
                  font-size: 12px;
                  color: #ffffff;
                  font-weight: bold;
                }

                .wf-btn-apply:hover {
                  background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
                  transform: translateY(-1px);
                  box-shadow: 0 6px 16px rgba(37, 99, 235, 0.2);
                }

                .wf-btn-apply:active {
                  transform: scale(0.97);
                }

                .wf-btn-reset {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  height: 38px;
                  padding: 0 18px;
                  border-radius: 10px;
                  border: 1px solid #cbd5e1;
                  background: #ffffff;
                  color: #475569;
                  font-size: 13.5px;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                  outline: none;
                }

                .wf-btn-reset i {
                  font-size: 12px;
                  color: #475569;
                }

                .wf-btn-reset:hover {
                  background: #f8fafc;
                  border-color: #94a3b8;
                  color: #1e293b;
                }

                 .wf-btn-reset:active {
                   transform: scale(0.97);
                 }

                 .wf-period-btn {
                   display: inline-flex;
                   align-items: center;
                   gap: 8px;
                   padding: 8px 14px;
                   border-radius: 12px;
                   background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
                   border: 1px solid rgba(191, 219, 254, 0.8);
                   font-size: 13px;
                   font-weight: 700;
                   color: #0f172a;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                   box-shadow: 0 2px 4px rgba(15, 23, 42, 0.02);
                 }
                 .wf-period-btn:hover {
                   background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                   border-color: rgba(37, 99, 235, 0.25);
                   transform: translateY(-1px);
                   box-shadow: 0 4px 8px rgba(37, 99, 235, 0.05);
                 }
                 .wf-period-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-period-icon {
                   color: #2563eb;
                   font-size: 12.5px;
                 }

                 .wf-metric-btn {
                   display: inline-flex;
                   flex-direction: column;
                   align-items: flex-start;
                   gap: 4px;
                   padding: 8px 14px;
                   border-radius: 12px;
                   background: linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%);
                   border: 1px solid rgba(191, 219, 254, 0.8);
                   color: #0f172a;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                   box-shadow: 0 2px 4px rgba(15, 23, 42, 0.02);
                 }
                 .wf-metric-btn:hover {
                   background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                   border-color: rgba(37, 99, 235, 0.25);
                   transform: translateY(-1px);
                   box-shadow: 0 4px 8px rgba(37, 99, 235, 0.05);
                 }
                 .wf-metric-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-metric-primary {
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                   font-size: 13.5px;
                   font-weight: 800;
                   line-height: 1.15;
                   color: #0f172a;
                 }
                 .wf-metric-primary i {
                   color: #2563eb;
                   font-size: 12px;
                 }
                 .wf-metric-secondary {
                   display: block;
                   color: #64748b;
                   font-size: 11px;
                   font-weight: 700;
                   text-transform: uppercase;
                   letter-spacing: 0.5px;
                   line-height: 1.2;
                 }

                 .wf-notes-btn {
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   gap: 8px;
                   border-radius: 999px;
                   border: 1px solid rgba(191, 219, 254, 0.8);
                   background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
                   color: #1d4ed8;
                   padding: 7px 14px;
                   font-size: 12px;
                   font-weight: 700;
                   cursor: pointer;
                   transition: all 0.2s ease;
                   outline: none;
                 }
                 .wf-notes-btn:hover {
                   background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
                   border-color: rgba(37, 99, 235, 0.3);
                   transform: translateY(-1px);
                 }
                 .wf-notes-btn:active {
                   transform: scale(0.97);
                 }
                 .wf-notes-badge {
                   min-width: 18px;
                   height: 18px;
                   border-radius: 999px;
                   display: inline-flex;
                   align-items: center;
                   justify-content: center;
                   background: #ffffff;
                   color: #1d4ed8;
                   font-size: 10px;
                   font-weight: 800;
                   padding: 0 4px;
                   border: 1px solid rgba(191, 219, 254, 0.5);
                   margin-left: 4px;
                 }

                 .wf-doc-list {
                   list-style: none;
                   margin: 0;
                   padding: 0;
                   display: flex;
                   flex-direction: column;
                   gap: 6px;
                 }
                 .wf-doc-row {
                   display: flex;
                   justify-content: space-between;
                   align-items: center;
                   gap: 8px;
                   padding: 6px 10px;
                   border: 1px solid #e2e8f0;
                   border-radius: 10px;
                   background: #ffffff;
                   box-shadow: 0 2px 6px rgba(15, 23, 42, 0.015);
                   transition: all 0.2s ease;
                 }
                 .wf-doc-row:hover {
                   border-color: #cbd5e1;
                   background: #f8fafc;
                   transform: translateY(-0.5px);
                 }
                 .wf-doc-link {
                   border: none;
                   background: transparent;
                   color: #2563eb;
                   padding: 0;
                   font-size: 12px;
                   font-weight: 700;
                   text-align: left;
                   word-break: break-all;
                   outline: none;
                   cursor: pointer;
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                 }
                 .wf-doc-link i {
                   color: #64748b;
                 }

                 .wf-status-stack {
                   display: flex;
                   flex-direction: column;
                   align-items: flex-start;
                   gap: 6px;
                 }
                 .wf-status-pill {
                   display: inline-flex;
                   align-items: center;
                   gap: 6px;
                   min-height: 28px;
                   padding: 4px 10px;
                   border-radius: 999px;
                   border: 1px solid transparent;
                   font-size: 11.5px;
                   font-weight: 700;
                   line-height: 1.2;
                   white-space: nowrap;
                   transition: all 0.2s ease;
                 }
                 .wf-status-pending {
                   color: #92400e;
                   background-color: #fffbeb;
                   border-color: #fde68a;
                 }
                 .wf-status-pending:hover {
                   background-color: #fef3c7;
                   border-color: #fcd34d;
                 }
                 .wf-status-approved {
                   color: #166534;
                   background-color: #f0fdf4;
                   border-color: #bbf7d0;
                 }
                 .wf-status-approved:hover {
                   background-color: #dcfce7;
                   border-color: #86efac;
                 }
                 .wf-status-rejected {
                   color: #991b1b;
                   background-color: #fef2f2;
                   border-color: #fecaca;
                 }
                 .wf-status-rejected:hover {
                   background-color: #fee2e2;
                   border-color: #fca5a5;
                 }
                 .wf-status-reviewed {
                   color: #1d4ed8;
                   background-color: #eff6ff;
                   border-color: #dbeafe;
                 }
                 .wf-status-reviewed:hover {
                   background-color: #dbeafe;
                   border-color: #bfdbfe;
                 }
                 .wf-status-date {
                   font-size: 11px;
                   color: #64748b;
                   line-height: 1.4;
                 }
                 .agency-invoices-table td {
                     vertical-align: top !important;
                 }
             `}</style>
      `
    </React.Fragment>
  );
}
